import * as Yup from 'yup';

const productFiltersSchema = Yup.object({
  manufacturer_id: Yup.string()
    .nullable()
    .label('Valmistaja'),
  search: Yup.string()
    .nullable()
    .label('Vapaa haku')
});

export default productFiltersSchema;
export type ProductFiltersSchema = ReturnType<typeof productFiltersSchema.cast>;
